export enum TicketModals {
  None,
  CreateTicket,
  EditTicket,
  TicketAttachments,
  MergeTicket,
}
